// import cv from "./CV.pdf";

export const socialLinks = [
	{ name: 'Twitter', link: 'https://www.instagram.com/11_rushya_/' },
	{ name: 'LinkedIn', link: 'https://www.linkedin.com/in/madarapu-rushya-shrungan-3b27b0268/' },
	{ name: 'Github', link: 'https://github.com/Rushya5' },
	// {name: "Resume", link: cv},
	{ name: 'Mail', link: 'https://mail.google.com/mail/?view=cm&fs=1&to=rushyashrungan05@gmail.com&su=Contact%20from%20Portfolio&body=Hello%20Rushya,' },
];
